<div class="section-cards" [formGroup]="formRegister">
  <section class="section-card">
    <div class="section-card__header">
      <div class="section-card__header-top">
      <div class="section-card__heading">
        <div class="section-header">
          <span class="section-header__accent" aria-hidden="true"></span>
          <h3 class="section-header__title">Proprietário</h3>
        </div>
        <p class="section-card__description">Responsável legal pela propriedade cadastrada.</p>
      </div>
      <span class="section-required-tag" aria-label="Obrigatório">Obrigatório</span>
      </div>
      <span class="section-card__divider" aria-hidden="true"></span>
    </div>
    <div class="fields-row fields-row--2">
      <div class="field-group field-group--labeled">
        <b3-input-text
          formControlName="landOwnerFullName"
          inputId="landOwnerFullName"
          label="Nome completo ou Razão Social do proprietário"
          background="white"
          mask="text"
          placeholder="Limite 100 caracteres"
          [maxlength]="100"
          [error]="checkHasError('landOwnerFullName')">
        </b3-input-text>
        <p class="character-count">
          {{ characterCount }}/100
        </p>
      </div>
      <div class="field-group field-group--labeled">
        <b3-input-text
          formControlName="landOwnerCpf"
          inputId="landOwnerCpf"
          label="CPF/CNPJ do proprietário"
          background="white"
          [mask]="ownerDocumentMask"
          placeholder="00.000.000/0000-00"
          [maxlength]="18"
          [error]="checkHasError('landOwnerCpf')"
          [hint]="[
            { show: checkHasError('landOwnerCpf', 'length'), text: 'O CPF/CNPJ deve conter 11 ou 14 dígitos.' },
            { show: checkHasError('landOwnerCpf', 'equalDigits'), text: 'Todos os dígitos não podem ser iguais.' },
            { show: checkHasError('landOwnerCpf', 'digit'), text: 'Dígito verificador inválido.' }
          ] | fieldHint"
          (b3-blur)="onChangesInputCpfOrCnpj()">
        </b3-input-text>
      </div>
    </div>
  </section>

  <section class="section-card">
    <div class="section-card__header">
      <div class="section-card__header-top">
      <div class="section-card__heading">
        <div class="section-header">
          <span class="section-header__accent" aria-hidden="true"></span>
          <h3 class="section-header__title">Localização</h3>
        </div>
        <p class="section-card__description">Dados geográficos da propriedade onde o projeto será executado.</p>
      </div>
      <span class="section-required-tag" aria-label="Obrigatório">Obrigatório</span>
      </div>
      <span class="section-card__divider" aria-hidden="true"></span>
    </div>
    <div class="fields-row fields-row--3">
      <div class="field-group field-group--labeled">
        <b3-input-text
          formControlName="country"
          inputId="country"
          label="País"
          background="white"
          mask="text"
          placeholder=""
          [disabled]="true">
        </b3-input-text>
      </div>
      <app-combo-uf-cidade [form]="formRegister" ufControl="uf" cityControl="city" ufLabel="UF" cityLabel="Município"
        ufPlaceholder="Selecione a UF" cityPlaceholder="Selecione o Município">
      </app-combo-uf-cidade>
    </div>
  </section>

  <section class="section-card">
    <div class="section-card__header">
      <div class="section-card__header-top">
      <div class="section-card__heading">
        <div class="section-header">
          <span class="section-header__accent" aria-hidden="true"></span>
          <h3 class="section-header__title">Coordenadas</h3>
        </div>
        <p class="section-card__description">Coordenadas geográficas utilizadas para localização e validação da área.</p>
      </div>
      <span class="section-required-tag" aria-label="Obrigatório">Obrigatório</span>
      </div>
      <span class="section-card__divider" aria-hidden="true"></span>
    </div>
    <div class="fields-row fields-row--2">
      <div class="field-group field-group--labeled">
        <b3-input-text
          formControlName="lat"
          inputId="lat"
          label="Latitude"
          background="white"
          mask="text"
          placeholder="00º00'00&quot;S"
          [maxlength]="50"
          [error]="checkHasError('lat')">
        </b3-input-text>
      </div>
      <div class="field-group field-group--labeled">
        <b3-input-text
          formControlName="long"
          inputId="long"
          label="Longitude"
          background="white"
          mask="text"
          placeholder="00º00'00&quot;O"
          [maxlength]="50"
          [error]="checkHasError('long')">
        </b3-input-text>
      </div>
    </div>
  </section>

  <section class="section-card">
    <div class="section-card__header">
      <div class="section-card__header-top">
      <div class="section-card__heading">
        <div class="section-header">
          <span class="section-header__accent" aria-hidden="true"></span>
          <h3 class="section-header__title">Área da propriedade</h3>
        </div>
        <p class="section-card__description">Área total registrada da propriedade em hectares.</p>
      </div>
      <span class="section-required-tag" aria-label="Obrigatório">Obrigatório</span>
      </div>
      <span class="section-card__divider" aria-hidden="true"></span>
    </div>
    <div class="fields-row fields-row--2">
      <div class="field-group field-group--labeled">
        <b3-input-text
          formControlName="totalHectares"
          inputId="totalHectares"
          label="Hectares totais"
          background="white"
          mask="integer"
          placeholder="Limite de 10 dígitos"
          [maxlength]="10"
          [error]="checkHasError('totalHectares')">
        </b3-input-text>
      </div>
      <div class="field-group field-group--labeled">
        <b3-input-text
          formControlName="carbonGenerationHectares"
          inputId="carbonGenerationHectares"
          label="Hectares de geração de carbono"
          background="white"
          mask="integer"
          placeholder="Limite de 10 dígitos"
          [maxlength]="10"
          [error]="checkHasError('carbonGenerationHectares')">
        </b3-input-text>
      </div>
      <div class="field-group field-group--labeled">
        <b3-input-text
          formControlName="availableHectares"
          inputId="availableHectares"
          label="Hectares disponíveis"
          background="white"
          mask="integer"
          placeholder="Limite de 10 dígitos"
          [disabled]="true">
        </b3-input-text>
      </div>
      <div class="field-group field-group--labeled">
        <b3-input-select
          formControlName="biome"
          inputId="biome"
          label="Bioma"
          placeholder="Selecione o Bioma"
          background="white"
          maxHeight="280px"
          [options]="selectBiome"
          [error]="checkHasError('biome')">
          <b3-input-select-option
            *ngFor="let item of selectBiome; let i = index"
            [attr.value]="item.inputId"
            [attr.index]="i"
            [id]="'biome-option-' + item.inputId">
            {{ item.label }}
          </b3-input-select-option>
        </b3-input-select>
      </div>
    </div>
  </section>

  <section class="section-card" id="add_others_owners">
    <div class="section-card__header">
      <div class="section-card__header-top">
        <div class="section-card__heading">
          <div class="section-header">
            <span class="section-header__accent" aria-hidden="true"></span>
            <h3 class="section-header__title">CAR</h3>
          </div>
          <p class="section-card__description">Identificador oficial do Cadastro Ambiental Rural da propriedade.</p>
        </div>
        <span class="section-required-tag" aria-label="Obrigatório">Obrigatório</span>
      </div>
      <span class="section-card__divider" aria-hidden="true"></span>
    </div>
    <div class="fields-row fields-row--2">
      <div class="field-group field-group--labeled">
        <b3-input-text
          formControlName="registrationRecord"
          inputId="registrationRecord"
          label="Registro de inscrição"
          background="white"
          mask="text"
          placeholder="Limite 150 caracteres"
          [maxlength]="150"
          [error]="checkHasError('registrationRecord')">
        </b3-input-text>
      </div>
      <div class="field-group field-group--labeled">
        <b3-input-text
          formControlName="onlineStatementLink"
          inputId="onlineStatementLink"
          label="Link do demonstrativo online"
          background="white"
          mask="link"
          placeholder="https://www.exemplo.com.br"
          autocomplete="url"
          [maxlength]="150"
          [error]="checkHasError('onlineStatementLink')">
        </b3-input-text>
      </div>
    </div>
  </section>

  <div class="section-card__include-action">
    <b3-button
      class="section-card__include-btn"
      type="button"
      variant="outlined"
      tone="default"
      [disabled]="includePropertyDisabled"
      (b3-click)="onIncludeProperty()">
      <b3-icon name="add" size="sm"></b3-icon>
      Incluir
    </b3-button>
  </div>

  <app-psa-add-others-owners
    #ownersList
    [formRegister]="formRegister"
    (ownersChanged)="syncIncludePropertyDisabled()">
  </app-psa-add-others-owners>
  <b3-message [statusError]="true" [show]="isLocationsMissing()">
    Inclua ao menos uma propriedade para continuar.
  </b3-message>
</div>
